/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Rust_Hawk_DrawInputs */

const en_sage_rust_hawk_draw = /** @type {(inputs: Sage_Rust_Hawk_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add topic`)
};

const de_sage_rust_hawk_draw = /** @type {(inputs: Sage_Rust_Hawk_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add topic" |
*
* @param {Sage_Rust_Hawk_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_rust_hawk_draw = /** @type {((inputs?: Sage_Rust_Hawk_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Rust_Hawk_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_rust_hawk_draw(inputs)
	return de_sage_rust_hawk_draw(inputs)
});